import React, { FC, ReactElement } from 'react';
import { useRouter } from 'next/router';

import { OfferAndFilters } from '../../interfaces';
import { Flight } from './details/Flight';
import { Destination } from './details/Destination';
import { Distance } from './details/Distance';
import { ImageRating } from './images/ImageRating';
import { SupplierLogo } from './images/SupplierLogo';
import { Price } from './details/Price';
import { Days } from './details/Days';
import { Meals } from './details/Meals';

import { addHotelPageFiltersToUrl, browserQueryParamFor } from '../../lib/utils/queryParamFilterConversions';
import { trackSeeMoreOffers } from '../tracking/FinnAnalytics';

export const ResultItemDetails: FC<OfferAndFilters> = ({ offer, filters }): ReactElement<OfferAndFilters> => {
    const {
        offerId,
        supplier,
        country,
        region,
        destination,
        distanceToBeach,
        distanceToCity,
        hotelId,
        hotelName,
        board,
        departureDate,
        returnDate,
        duration,
        rating,
    } = offer;
    const router = useRouter();

    return (
        <div className="grid__unit u-r-size3of5 u-m-ph16 u-mt0" key={offerId}>
            <div className="u-mt32 u-hide-lt900" />
            <ImageRating id={offerId} rating={rating} emptyStars className="u-float-right" />
            <Destination country={country} region={region} destination={destination} hotelName={hotelName} />

            <div className="grid">
                <div className="u-size2of3 grid__unit u-t5">
                    <Distance distanceToBeach={distanceToBeach} distanceToCity={distanceToCity} />
                </div>
                <div className="grid__unit u-size1of3">
                    <SupplierLogo supplier={supplier} className="u-mb4 u-float-right" />
                </div>
            </div>
            <div className="grid u-mt2">
                <div className="u-size3of4 u-float-left">
                    <div className="grid__unit u-d1 u-mr16">
                        <Flight departureDate={departureDate} returnDate={returnDate} />
                    </div>
                    <div className="grid__unit u-d1" data-testid="offerNights">
                        <Days duration={duration} />
                        <Meals board={board} />
                    </div>
                    <div className="grid__unit u-t5 u-mt8 u-cb">
                        <a
                            href={addHotelPageFiltersToUrl(
                                `${router.basePath}/hotell?${browserQueryParamFor('hotelId', hotelId)}`,
                                filters
                            )}
                            onClick={() => trackSeeMoreOffers(offerId, hotelName)}
                            rel="nofollow"
                            data-testid={`resultDetailLink-${hotelId}`}
                            className="resultItem__link">
                            Se flere reisealternativer
                        </a>
                    </div>
                </div>
                <div className="u-size1of4 u-float-left">
                    <Price {...offer} />
                </div>
            </div>
            <div className="u-mt32 u-hide-gt768" />
        </div>
    );
};
